import React from 'react';
import { Link } from 'react-router-dom';

const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);

export default function MembershipCard({ membership }) {
  const photo = (membership.photos && membership.photos[0]) || `https://placehold.co/640x360/0a1a2e/ffffff?text=${encodeURIComponent(membership.make + ' ' + membership.model)}`;
  return (
    <Link to={`/memberships/${membership._id}`} className="membership-card">
      <div className="membership-photo" style={{ backgroundImage: `url(${photo})` }} />
      <div className="membership-body">
        <div className="membership-title">{membership.year} {membership.make} {membership.model}</div>
        <div className="membership-meta">{(membership.mileage || 0).toLocaleString()} mi · {membership.bodyStyle} · {membership.fuelType}</div>
        <div className="membership-price">{fmt(membership.price)}</div>
      </div>
    </Link>
  );
}
